import { makeAutoObservable } from "mobx";
import { sitchEventAuthForEvent } from "../../../../../api/sitch_events";
import CommunityNavigationStore from "../../navigation/communityNavigationStore";

export class EventCodeStore {
  eventCode = "";

  isLoading = false;

  error: string | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setEventCode(code: string) {
    this.eventCode = code;
    this.error = null;
  }

  async submitEventCode(eventGuid: string): Promise<boolean> {
    if (!this.eventCode.trim()) {
      this.error = "Please enter an event code";
      return false;
    }

    this.isLoading = true;
    this.error = null;

    try {
      const authResponse = await sitchEventAuthForEvent({
        event: eventGuid,
        code: this.eventCode,
      });

      if (!authResponse.success) {
        this.error = "Invalid event code. Please try again.";
        return false;
      }

      return true;
    } catch (err) {
      console.log(err);
      return false;
    } finally {
      this.isLoading = false;
    }
  }

  clearSession(eventGuid?: string) {
    this.eventCode = "";
    this.error = null;
    this.isLoading = false;

    if (eventGuid) {
      CommunityNavigationStore.clearEventAuthentication(eventGuid);
    }
  }

  get isValid() {
    return Boolean(this.eventCode.trim());
  }
}

export default new EventCodeStore();
